import {ChangeDetectionStrategy, Component} from '@angular/core';
import {AllCrmSections, CrmSection} from '@enum/crm-section';
import {AuthService} from '@service/auth/auth.service';
import {CustomIconType} from '@enum/icons/icon-type';

type MenuItem = { url: string; title: string; icon: CustomIconType, sections: ReadonlyArray<CrmSection> };

@Component({
    selector: 'app-menu-crm',
    templateUrl: './menu-crm.component.html',
    styleUrls: ['./menu-crm.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MenuCrmComponent {
  private readonly localStorageCrmMenuExpandedKey = 'crmMenuExpanded';
  menuItems: MenuItem[];
  expanded = true;
  prefixLabel = 'CRM.MENU.';
  canLoadAnimation = false;

  constructor(private authService: AuthService) {
    this.expanded = localStorage.getItem(this.localStorageCrmMenuExpandedKey) !== '0';
    const allMenuItems: MenuItem[] = [
      {url: './dashboard', title: 'DASHBOARD', icon: 'icon-ipe-dashboard', sections: AllCrmSections},
      {url: './customers', title: 'CUSTOMERS', icon: 'icon-ipe-customers', sections: [CrmSection.Lead, CrmSection.VerifiedContact, CrmSection.CustomerList]},
      {url: './tasks', title: 'SALES_TASKS', icon: 'icon-ipe-sales-tasks', sections: [CrmSection.SalesTasks]},
      {url: './messages', title: 'MESSAGES', icon: 'icon-ipe-unread-mail', sections: [CrmSection.Messages]},
      {url: './claims', title: 'CLAIMS', icon: 'icon-ipe-communications-chat', sections: [CrmSection.Claims]},
      {url: './preferences', title: 'PREFERENCES', icon: 'fa-cogs', sections: [CrmSection.Preferences]},
/* todo coming soon
      {url: './orders', title: 'ORDERS', icon: 'icon-ipe-orders-06', sections: [CrmSection.Orders]},
      {url: './report', title: 'REPORT', icon: 'icon-ipe-pie-chart', sections: [CrmSection.Report]},
      {url: './assistance', title: 'ASSISTANCE', icon: 'icon-ipe-faq-assistance', sections: AllCrmSections},
      {url: './info', title: 'INFO', icon: 'icon-ipe-info', sections: AllCrmSections},
*/
    ];
    this.menuItems = allMenuItems.filter((item) => authService.currentUserPermission.crmSectionsVisible.some((s) => item.sections.includes(s)));
  }

  toggleExpand(): void {
    this.canLoadAnimation = true;
    this.expanded = !this.expanded;
    localStorage.setItem(this.localStorageCrmMenuExpandedKey, String(+this.expanded));
  }
}
